<template>
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33317 1.51318V4.26688C8.33317 4.64025 8.33317 4.82693 8.40583 4.96954C8.46975 5.09498 8.57173 5.19697 8.69718 5.26088C8.83978 5.33354 9.02647 5.33354 9.39984 5.33354H12.1535M5.33317 8.00016L8.6665 11.3335M8.6665 8.00016L5.33317 11.3335M8.33317 1.3335H4.8665C3.7464 1.3335 3.18635 1.3335 2.75852 1.55148C2.3822 1.74323 2.07624 2.04919 1.88449 2.42552C1.6665 2.85334 1.6665 3.41339 1.6665 4.5335V11.4668C1.6665 12.5869 1.6665 13.147 1.88449 13.5748C2.07624 13.9511 2.3822 14.2571 2.75852 14.4488C3.18635 14.6668 3.7464 14.6668 4.8665 14.6668H9.13317C10.2533 14.6668 10.8133 14.6668 11.2412 14.4488C11.6175 14.2571 11.9234 13.9511 12.1152 13.5748C12.3332 13.147 12.3332 12.5869 12.3332 11.4668V5.3335L8.33317 1.3335Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
